var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"width":"100%","vertical-align":"middle"},attrs:{"src":require("@/assets/ida-logo-small.png"),"alt":"IDA Logo"}})}
var staticRenderFns = []

export { render, staticRenderFns }